import React, { Component } from 'react'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import { compose } from 'recompose'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import Switch from '@material-ui/core/Switch'

import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import TextField from '@material-ui/core/TextField'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme, withTheme } from '@material-ui/core/styles'
import { associateRequest } from 'utils/helpers'
import { paths } from 'routes'
import { navigate } from 'gatsby'

const withMediaQuery = (queries = []) => (Component) => (props) => {
	const mediaProps = {}
	queries.forEach((q) => {
		mediaProps[q[0]] = useMediaQuery(q[1])
	})
	return <Component {...mediaProps} {...props} />
}

const SYMPTOM_TARGETS = [
	{
		label: 'Abdominal Pain',
		value: 'Abdominal Pain',
	},
	{
		label: 'Belching',
		value: 'Belching',
	},
	{
		label: 'Constipation',
		value: 'Constipation',
	},
	{
		label: 'Diarrhea',
		value: 'Diarrhea',
	},
	{
		label: 'Distention',
		value: 'Distention',
	},
	{
		label: 'Early Satiety',
		value: 'Early Satiety',
	},
	{
		label: 'Flatulence',
		value: 'Flatulence',
	},
	{
		label: 'Nausea/Vomiting',
		value: 'Nausea/Vomiting',
	},
	{
		label: 'Reflux/Hearburn',
		value: 'Reflux/Hearburn',
	},
	{
		label: 'Other',
		value: 'Other',
	},
]

const SYMPTOM_DURATIONS = [
	{
		label: '1 Day',
		value: 86400,
	},
	{
		label: '5 Days',
		value: 432000,
	},
	{
		label: '1 Week',
		value: 604800,
	},
	{
		label: '2 Weeks',
		value: 1210000,
	},
	{
		label: '3 Weeks',
		value: 1814400,
	},
	{
		label: '1 Month',
		value: 2628000,
	},
	{
		label: '2 Months',
		value: 5256000,
	},
	{
		label: 'Self Bounded',
		value: 0,
	},
]

const useForkStyles = (theme) => ({
	container: {
		minWidth: 500,
	},
	formControl: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
		width: '100%',
	},
})

class InterventionForkState extends Component {
	state = {
		allowDuration: false,
		name: this.props.intervention.current?.meta?.friendlyName,
		duration: this.props.intervention.current?.duration,
		symptom: this.props.intervention.current?.symptom,
		recommendation: this.props.intervention.current?.recommendation,
		meta: this.props.intervention.current?.meta,
	}

	static getDerivedStateFromProps(props, state) {
		if (state.id !== props.intervention.current?.id) {
			return {
				id: props.intervention.current?.id,
				allowDuration: false,
				name: props.intervention.current?.meta?.friendlyName,
				duration: props.intervention.current?.duration,
				symptom: props.intervention.current?.symptom,
				recommendation: props.intervention.current?.recommendation,
				meta: props.intervention.current?.meta,
			}
		}

		return state
	}

	onNameChange = (name) => {
		// this.props.setCurrentIntervention({
		// 	...this.props.intervention.current,
		// 	name,
		// 	meta: {
		// 		...this.props.intervention.current.meta,
		// 		friendlyName: name,
		// 	},
		// })
		this.setState({
			...this.state,
			name,
			meta: {
				...this.props.intervention.current.meta,
				friendlyName: name,
			},
		})
	}

	onSelectSymptomType = (symptomType) => {
		// this.props.setCurrentIntervention({
		// 	...this.props.intervention.current,
		// 	symptom: symptomType,
		// })
		this.setState({ ...this.state, symptom: symptomType })
	}

	onRecommendationChange = (recommendation) => {
		// this.props.setCurrentIntervention({
		// 	...this.props.intervention.current,
		// 	recommendation: recommendation,
		// })
		this.setState({ ...this.state, recommendation: recommendation })
	}

	onSelectInterventionDuration = (duration) => {
		// this.props.setCurrentIntervention({
		// 	...this.props.intervention.current,
		// 	duration: duration,
		// })
		this.setState({ ...this.state, duration: duration })
	}

	toggleDuration = () => {
		const newState = { ...this.state, allowDuration: !this.state.allowDuration }
		if (this.state.allowDuration) {
			newState.duration = null
		}
		this.setState(newState)
		// if (!this.state.allowDuration) {

		// 	this.props.setCurrentIntervention({
		// 		...this.props.intervention.current,
		// 		duration: null,
		// 	})
		// }
	}

	createNewIntervention = () => {
		this.props.addIntervention(
			associateRequest(
				{
					name: this.state.name,
					duration: this.state.duration,
					symptom: this.state.symptom,
					recommendation: this.state.recommendation,
					meta: this.state.meta,
					creator_key: this.props.auth.sub,
				},
				'intervention'
			)
		)
		this.props.handleClose()
		navigate(paths.interventions)
	}

	render() {
		const {
			auth,
			classes,
			fullScreen,
			open = false,
			intervention,
			addIntervention,
			handleClose = () => {},
		} = this.props

		const isValid = this.state.symptom && this.state.name && this.state.recommendation
		return (
			<Dialog
				fullScreen={fullScreen}
				disableEscapeKeyDown
				open={open}
				TransitionProps={{
					onClose: handleClose,
				}}
				aria-labelledby="create-intervention"
			>
				<DialogTitle id="create-intervention">Create Self Experiment</DialogTitle>
				<DialogContent className={classes.container}>
					<Grid container spacing={2} direction="column" justifyContent="flex-start" alignItems="flex-start">
						<FormControl variant="outlined" className={classes.formControl}>
							<InputLabel id="experiment-symptom-group">Symptom Target:</InputLabel>
							<Select
								labelId="experiment-symptom-group"
								id="experiment-symptom-group-options"
								value={this.state.symptom}
								onChange={(event) => this.onSelectSymptomType(event.target.value)}
							>
								{SYMPTOM_TARGETS.map((tg, i) => {
									return (
										<MenuItem key={i} value={tg.value} name={tg.label}>
											{tg.label}
										</MenuItem>
									)
								})}
							</Select>
						</FormControl>
						<FormControl variant="outlined" className={classes.formControl}>
							<TextField
								variant="outlined"
								id="experiment-name"
								label="Experiment Name"
								value={this.state?.meta?.friendlyName}
								onChange={(event) => this.onNameChange(event.target.value)}
							/>
						</FormControl>
						<FormControl variant="outlined" className={classes.formControl}>
							<TextField
								id="experiment-recommendation"
								label="Instructions"
								multiline
								rows={4}
								variant="outlined"
								value={this.state.recommendation}
								onChange={(event) => this.onRecommendationChange(event.target.value)}
							/>
						</FormControl>
						<FormControl variant="outlined" className={classes.formControl}>
							<Grid container direction="row" justifyContent="flex-start" alignItems="center">
								<Grid item>
									<Typography variant="body1">Duration:</Typography>
								</Grid>
								<Grid item>
									<Switch
										checked={this.state.allowDuration}
										color="primary"
										onChange={this.toggleDuration}
										name="Time Constrained"
										inputProps={{ 'aria-label': 'Time Constrained' }}
									/>
								</Grid>
							</Grid>
						</FormControl>
						{this.state.allowDuration ? (
							<FormControl variant="outlined" className={classes.formControl}>
								<InputLabel id="experiment-symptom-duration">Duration:</InputLabel>
								<Select
									labelId="experiment-symptom-duration"
									id="experiment-symptom-duration-options"
									value={this.state.duration}
									onChange={(event) => this.onSelectInterventionDuration(event.target.value)}
								>
									{SYMPTOM_DURATIONS.map((dur, i) => {
										return (
											<MenuItem key={i} value={dur.value} name={dur.label}>
												{dur.label}
											</MenuItem>
										)
									})}
								</Select>
							</FormControl>
						) : (
							<>Self Bounded</>
						)}
					</Grid>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} variant="contained">
						Close
					</Button>
					<Button onClick={this.createNewIntervention} variant="contained" disabled={!isValid} autoFocus>
						Create and Assign
					</Button>
				</DialogActions>
			</Dialog>
		)
	}
}

const InterventionForkStateComp = compose(
	withStyles(useForkStyles),
	withMediaQuery([
		[
			'fullScreen',
			(theme) => theme.breakpoints.down('sm'),
			{
				defaultMatches: true,
			},
		],
	])
)(InterventionForkState)

const useFinalizeStyles = makeStyles((theme) => ({}))

function InterventionFinalizeState({ open = false, intervention, addIntervention, handleClose = () => {} }) {
	const theme = useTheme()

	const classes = useFinalizeStyles()
	const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))
	const assignIntervention = async () => {
		await addIntervention(
			associateRequest(
				{
					id: intervention.current.id,
				},
				'intervention'
			)
		)
		handleClose()
		navigate(paths.interventions)
	}

	return (
		<Dialog
			fullScreen={fullScreen}
			disableEscapeKeyDown
			open={open}
			TransitionProps={{
				onClose: handleClose,
			}}
			aria-labelledby="create-intervention"
		>
			<DialogTitle id="create-intervention">Self Experiment Assignment</DialogTitle>
			<DialogContent>
				Do you want to assign the {intervention.current?.meta?.friendlyName || intervention.current.name} new
				experiment to the patient now?
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} variant="contained">
					Close
				</Button>
				<Button onClick={assignIntervention} variant="contained" autoFocus>
					Assign
				</Button>
			</DialogActions>
		</Dialog>
	)
}

function InterventionCreateDialog({
	open = false,
	finalize = false,
	auth,
	intervention,
	addIntervention,
	handleClose = () => {},
	setCurrentIntervention,
	clearCurrentIntervention,
}) {
	return finalize ? (
		<InterventionForkStateComp
			open={open}
			auth={auth}
			intervention={intervention}
			addIntervention={addIntervention}
			setCurrentIntervention={setCurrentIntervention}
			clearCurrentIntervention={clearCurrentIntervention}
			handleClose={handleClose}
		/>
	) : (
		<InterventionFinalizeState
			open={open}
			auth={auth}
			intervention={intervention}
			addIntervention={addIntervention}
			setCurrentIntervention={setCurrentIntervention}
			clearCurrentIntervention={clearCurrentIntervention}
			handleClose={handleClose}
		/>
	)
}

export { InterventionCreateDialog }
